/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ProductUnifiedProductsViewSingleUnifiedQueryVariables = {
    id: string;
};
export type ProductUnifiedProductsViewSingleUnifiedQueryResponse = {
    readonly getUnifiedProduct: {
        readonly id: string;
        readonly systemId: string;
        readonly compactData: unknown | null;
        readonly isShadow: boolean | null;
        readonly collection: {
            readonly id: string;
            readonly name: string;
        } | null;
        readonly brand: {
            readonly id: string;
            readonly name: string;
            readonly systemId: string;
        };
        readonly createdDate: unknown;
        readonly stockQuantity: number;
    } | null;
};
export type ProductUnifiedProductsViewSingleUnifiedQuery = {
    readonly response: ProductUnifiedProductsViewSingleUnifiedQueryResponse;
    readonly variables: ProductUnifiedProductsViewSingleUnifiedQueryVariables;
};



/*
query ProductUnifiedProductsViewSingleUnifiedQuery(
  $id: ID!
) {
  getUnifiedProduct(id: $id) {
    id
    systemId
    compactData
    isShadow
    collection {
      id
      name
    }
    brand {
      id
      name
      systemId
    }
    createdDate
    stockQuantity
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UnifiedProductNode",
    "kind": "LinkedField",
    "name": "getUnifiedProduct",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "compactData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isShadow",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductCollectionNode",
        "kind": "LinkedField",
        "name": "collection",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BrandNode",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stockQuantity",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductUnifiedProductsViewSingleUnifiedQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductUnifiedProductsViewSingleUnifiedQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "72cbc791a8f939dd440519a4e9b46e1c",
    "id": null,
    "metadata": {},
    "name": "ProductUnifiedProductsViewSingleUnifiedQuery",
    "operationKind": "query",
    "text": "query ProductUnifiedProductsViewSingleUnifiedQuery(\n  $id: ID!\n) {\n  getUnifiedProduct(id: $id) {\n    id\n    systemId\n    compactData\n    isShadow\n    collection {\n      id\n      name\n    }\n    brand {\n      id\n      name\n      systemId\n    }\n    createdDate\n    stockQuantity\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd961fe48ddecd442388497e8a674d688';
export default node;
